
import { NSFunctions } from './utils/functions';
import { NSDataModelInfo } from './data_model_info';

import { OverlaysVT } from './overlays_vt.js';
import { OverlaysWMTS } from './overlays_wmts.js';
import { OverlaysVector } from './overlays_vector.js';

//console.log("overlays.js - 01")

export let Overlays = {};

Overlays.init = function () {

  OverlaysVT.init(o_struct_overlays);
  OverlaysWMTS.init(o_struct_overlays);
  OverlaysVector.init(o_struct_overlays);


  window.NSOverlays_ = Overlays;
  window.o_struct_overlays_ = o_struct_overlays;

}


/*
    @tree_node -> LayersTree.objs.TreeNode
*/
Overlays.f_add_layer = function (tree_node) {

  //console.log("Overlays.f_add_layer")
  //console.log(tree_node);


  if 
  (
    //tree_node.type == 'vt' || 
    tree_node.type.startsWith('vt')
  ) 
  {
    OverlaysVT.f_add_vector_tiles_layer(tree_node);
  }
  else if ( tree_node.type == 'wmts' ) 
  {
    OverlaysWMTS.f_add_wmts_layer(tree_node);
  }
  else if ( tree_node.type == 'vector' ) 
  {
    OverlaysVector.f_add_vector_layer(tree_node);
  }
  else 
  {
    console.error("overlays - tree_node.type not recognized");
  }
}

/*
    @tree_node -> LayersTree.objs.TreeNode
*/
Overlays.f_remove_layer = function (tree_node) {

  //console.log("Overlays.f_remove_layer")
  //console.log(tree_node);

  if (
    //tree_node.type == 'vt' || 
    tree_node.type.startsWith('vt')
  ) 
  {
    OverlaysVT.f_remove_vector_tiles_layer(tree_node);
  }
  else if (tree_node.type == 'wmts') 
  {
    OverlaysWMTS.f_remove_wmts_layer(tree_node);
  }
  else if (tree_node.type == 'vector') 
  {
    OverlaysVector.f_remove_vector_layer(tree_node);
  }
  else {
    console.error("overlays - tree_node.type not recognized: " + tree_node.type);
  }
}

/*
    @tree_node -> LayersTree.objs.TreeNode
*/
Overlays.f_refresh_layer = function (tree_node) {

  //console.log("Overlays.f_refresh_layer")
  //console.log(tree_node);

  if(tree_node!= null)
  {
    this.f_remove_layer(tree_node);
    this.f_add_layer(tree_node);
  }

  
}
Overlays.f_refresh_layer_by_tree_node_id = function (tree_node_id) {

  //console.log("Overlays.f_refresh_layer")
  //console.log(tree_node_id);

  let overlay = o_struct_overlays.f_get_overlay(tree_node_id);
  if(overlay!= null)
  {
    let tree_node = overlay.tree_node;

    this.f_remove_layer(tree_node);
    this.f_add_layer(tree_node);
  }
  

  
}
Overlays.f_refresh_layers_by_table_urn = function (s_table_urn) {

  //console.log("Overlays.f_refresh_layers_by_table_urn")
  //console.log(s_table_urn);

  // processing layers that directly use submited table urn
  let a_overlays = o_struct_overlays.f_get_overlays_by_table_urn(s_table_urn);

  a_overlays.forEach(overlay_i => {
    this.f_refresh_layer_by_tree_node_id(overlay_i.tree_node_id);    
  });

  // processing layers that are dependant of submited table urn
  let o_table_info = NSDataModelInfo.f_get_table_info_by_table_urn(s_table_urn);
  let a_list_of_tables_with_dependent_geoserver_tile_layer = o_table_info.extra.a_list_of_tables_with_dependent_geoserver_tile_layer;
  if(a_list_of_tables_with_dependent_geoserver_tile_layer != null)
  {
    a_list_of_tables_with_dependent_geoserver_tile_layer.forEach((s_table_urn_j) =>
    {
      let a_overlays_j = o_struct_overlays.f_get_overlays_by_table_urn(s_table_urn_j);

      a_overlays_j.forEach(overlay_j => 
      {
        this.f_refresh_layer_by_tree_node_id(overlay_j.tree_node_id);    
      });
      
    });
  }
  

}


Overlays.f_get_tree_node_is_of_tile_type = function (tree_node_id) {

  //console.log("Overlays.f_get_tree_node_is_wmts");
  //console.log(tree_node_id);

  let overlay = o_struct_overlays.f_get_overlay(tree_node_id);
  let tree_node = overlay.tree_node;

  let b_tree_node_is_of_tile_type = (tree_node.type == 'wmts')? true : false;

  return b_tree_node_is_of_tile_type;
  
}



Overlays.f_get_all_active_overlays = function()
{
  return o_struct_overlays.f_get_all_active_overlays();
}

let o_struct_overlays = {

  a_vector_tiles_overlays: [],    // [{objs.OverlayVT}]
  a_wmts_overlays: [],            // [{objs.OverlayWMTS}]
  a_vector_overlays: [],          // [{objs.OverlayVector}]


  f_get_all_active_overlays: function()
  {
    return this.a_vector_tiles_overlays.concat(this.a_wmts_overlays, this.a_vector_overlays);
  },

  // overlay -> {objs.OverlayVT}
  f_add_vt_overlay: function (overlay) {
    this.a_vector_tiles_overlays.push(overlay);
  },

  f_remove_vt_overlay: function (tree_node_id) {
    let i_pos = this.f_get_vt_overlay_pos(tree_node_id);

    if (i_pos > -1) {
      this.a_vector_tiles_overlays.splice(i_pos, 1);
    }

  },

  f_get_overlay: function (tree_node_id)
  {
    let overlay = this.f_get_vt_overlay(tree_node_id);
    if(overlay != null) return overlay;

    overlay = this.f_get_wmts_overlay(tree_node_id);
    if(overlay != null) return overlay;

    overlay = this.f_get_vector_overlay(tree_node_id);
    return overlay;

  },

  f_get_overlays_by_table_urn: function (s_table_urn)
  {
    let a_overlays_vt = this.f_get_vt_overlays_by_table_urn(s_table_urn);
    let a_overlays_vector = this.f_get_vector_overlays_by_table_urn(s_table_urn);
    let a_overlays_wmts = this.f_get_wmts_overlays_by_table_urn(s_table_urn);
    
    let a_overlays = a_overlays_vt.concat(a_overlays_vector, a_overlays_wmts);

    return a_overlays;

  },


  f_get_vt_overlay: function (tree_node_id) {
    let i_pos = this.f_get_vt_overlay_pos(tree_node_id);

    if(i_pos>-1)
    {
      return this.a_vector_tiles_overlays[i_pos];
    }


  },

  f_get_vt_overlay_pos: function (tree_node_id) {
    //obj -> Id do elemento a encontrar
    //array -> array alvo da pesquisa
    //fEqual(o1,o2) - o1->obj - o2->elemento da lista a comparar numa iteração
    let i_pos = NSFunctions.getArrayPos(tree_node_id, this.a_vector_tiles_overlays,
      (o1, o2) => { return o1 == o2.tree_node_id; }
    );


    return i_pos;
  },

  f_get_vt_overlays_by_table_urn: function(s_table_urn)
  {
    let a_overlays = []
    this.a_vector_tiles_overlays.forEach(overlay_i => {
      if(overlay_i.tree_node.urn == s_table_urn)
      {
        a_overlays.push(overlay_i);
      }
    });
    return a_overlays;
  },


  //------------
  //WMTS Section
   // overlay -> {objs.OverlayVT}
   f_add_wmts_overlay: function (overlay) {
    this.a_wmts_overlays.push(overlay);
  },

  f_remove_wmts_overlay: function (tree_node_id) {
    let i_pos = this.f_get_wmts_overlay_pos(tree_node_id);

    if (i_pos > -1) {
      this.a_wmts_overlays.splice(i_pos, 1);
    }

  },

  f_get_wmts_overlay: function (tree_node_id) {
    let i_pos = this.f_get_wmts_overlay_pos(tree_node_id);

    if (i_pos > -1) {
      return this.a_wmts_overlays[i_pos];
    }

  },

  f_get_wmts_overlay_pos: function (tree_node_id) {
    //obj -> Id do elemento a encontrar
    //array -> array alvo da pesquisa
    //fEqual(o1,o2) - o1->obj - o2->elemento da lista a comparar numa iteração
    let i_pos = NSFunctions.getArrayPos(tree_node_id, this.a_wmts_overlays,
      (o1, o2) => { return o1 == o2.tree_node_id; }
    );


    return i_pos;
  },

  f_get_wmts_overlays_by_table_urn: function(s_table_urn)
  {
    let a_overlays = []
    this.a_wmts_overlays.forEach(overlay_i => {
      if(overlay_i.tree_node.urn == s_table_urn)
      {
        a_overlays.push(overlay_i);
      }
    });
    return a_overlays;
  },

  //------------
  //Vector Section
  // overlay -> {objs.OverlayVector}
  f_add_vector_overlay: function (overlay) {
    this.a_vector_overlays.push(overlay);
  },

  f_remove_vector_overlay: function (tree_node_id) {
    let i_pos = this.f_get_vector_overlay_pos(tree_node_id);

    if (i_pos > -1) {
      this.a_vector_overlays.splice(i_pos, 1);
    }

  },

  f_get_vector_overlay: function (tree_node_id) {
    let i_pos = this.f_get_vector_overlay_pos(tree_node_id);

    if (i_pos > -1) {
      return this.a_vector_overlays[i_pos];
    }

  },

  f_get_vector_overlay_pos: function (tree_node_id) {
    //obj -> Id do elemento a encontrar
    //array -> array alvo da pesquisa
    //fEqual(o1,o2) - o1->obj - o2->elemento da lista a comparar numa iteração
    let i_pos = NSFunctions.getArrayPos(tree_node_id, this.a_vector_overlays,
      (o1, o2) => { return o1 == o2.tree_node_id; }
    );


    return i_pos;
  },

  f_get_vector_overlays_by_table_urn: function(s_table_urn)
  {
    let a_overlays = []
    this.a_vector_overlays.forEach(overlay_i => {
      if(overlay_i.tree_node.urn == s_table_urn)
      {
        a_overlays.push(overlay_i);
      }
    });
    return a_overlays;
  }


};




var objs = {};
/*
    
    o_in: {
        tree_node: LayersTree.objs.TreeNode 
    }
*/
objs.OverlayVT = function (o_in) 
{
  this.tree_node_id = o_in.tree_node.id;
  this.tree_node = o_in.tree_node;          // LayersTree.objs.TreeNode 
  this.o_vtl = null;                        // VectorTileLayer from 'ol/layer/VectorTile';
  //this.o_vtl_selection = null;              // VectorTileLayer from 'ol/layer/VectorTile';
}

/*
    
    o_in: {
        tree_node: LayersTree.objs.TreeNode 
    }
*/
objs.OverlayWMTS = function (o_in) 
{
  this.tree_node_id = o_in.tree_node.id;
  this.tree_node = o_in.tree_node;            // LayersTree.objs.TreeNode 
  this.o_wmts_layer = null;                   // TileLayer from 'ol/layer/Tile';
  this.o_wms_layer_selection = null;          // TileLayer from 'ol/layer/Tile';
  this.map_click_listner_key = null;
  this.map_moveend_listener_key = null;
  this.map_zoom_change_previous_value = null;
  this.o_wmts_source_default_options = null;  // default options for source of TileLayer
}

/*
    
    o_in: {
        tree_node: LayersTree.objs.TreeNode 
    }
*/
objs.OverlayVector = function (o_in) 
{
  this.tree_node_id = o_in.tree_node.id;
  this.tree_node = o_in.tree_node;          // LayersTree.objs.TreeNode 
  this.o_vl = null;                        // VectorLayer from 'ol/layer/Vector';
  //this.o_vl_selection = null;              // VectorLayer from 'ol/layer/Vector';
}

Overlays.objs = objs;

